<app-header [title]="Title"></app-header>

<div class="row">
  <div class="col-md-12 pull-left mt-10 border-b pb-10">
    <span class="pull-left mr-10 label-std control-label b-600 w-auto formLabel pt-5">Client List</span>
    <span class="pull-left mr-10 pt-3 wt-120">
      <select class="form-control" (change)="ClientListOnChange()" [(ngModel)]="ClientId">
        <option value="0">Select</option>
        <option *ngFor="let c of ClientList" [value]="c.Client_Id" [selected]="c.selected">{{c.Client_Name}}
        </option>
      </select>
    </span>
    <span class="pull-left mr-10 label-std control-label b-600 w-auto formLabel pt-5">Status</span>
    <span class="pull-left mr-10 pt-3">
      <select class="form-control" (change)="OnActionChange()" [(ngModel)]="Action">
        <option *ngFor="let a of ActionList" [value]="a.Value">{{a.Key}}
        </option>
      </select>
    </span>
    <span class="pull-left mr-10 label-std control-label b-600 w-auto formLabel pt-5">From Date</span>
    <span class="pull-left mr-10 pt-3">
      <div class="input-group date" id="datetimepicker1">
        <input autocomplete="off" [min]="MinDate" [max]="maxDate1" [(ngModel)]="FromDate"
          (dateTimeInput)="FromDateOnChange()" (keydown)="BlockInput($event)" (keypress)="BlockInput($event)"
          [owlDateTimeTrigger]="dt1" class="form-control col-md-10" name="date" [owlDateTime]="dt1">
        <span class="input-group-addon col-md-2" [owlDateTimeTrigger]="dt1">
          <span class="fa fa-calendar"></span>
        </span>
        <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>

      </div>
      <span class="error" *ngIf="StartDatevalidationError">
        From Date should be less than To Date.
      </span>

    </span>
    <span class="pull-left mr-10 label-std control-label b-600 w-auto formLabel pt-5">To Date</span>
    <span class="pull-left mr-10 pt-3">

      <div class="input-group date" id="datetimepicker2">
        <input autocomplete="off" [min]="MinDate" [max]="maxDate1" [(ngModel)]="ToDate" (keydown)="BlockInput($event)"
          (dateTimeInput)="ToDateOnChange()" (keypress)="BlockInput($event)" [owlDateTimeTrigger]="dt2"
          class="form-control col-md-10" name="date" [owlDateTime]="dt2">
        <span class="input-group-addon col-md-2" [owlDateTimeTrigger]="dt2">
          <span class="fa fa-calendar"></span>
        </span>
        <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
      </div>
      <span class="error" *ngIf="ToDatevalidationError">
        To Date should be greater than From Date.
      </span>

    </span>
    <span>
      <button class="btn blue square-btn blue-hover btn-txt mr-10 btn-default"
        [disabled]="DisableSearch || ClientId == 0" (click)="getAgingWithCategory()" style="margin-top: 1rem;">Search</button>
    </span>
  </div>
  <div *ngIf="ShowMain" class="row col-md-3 p-0 blue-seprator sum-assist serpartion-htg">
    <div class="col-md-12 col-sm-12 p-0">
      <div class="heading-panel ptb-0">
        <span class="text-sm text-ellipsis heading-txt t-uppercase blue-text">Summary</span>
      </div>
      <div class="summary-gp">
        <div class="d-block summary-text-subt mt-0 col-md-12 col-sm-12 col-xs-12">TL summary view
          <div class="col-md-12 p-0 summary-text">
            <table class="summaryTable" width="100%">

              <tbody>
                <tr *ngFor="let s of Summary.TL_Summary">
                  <td>{{s.Summary_Name}}</td>
                  <td class="text-right">{{s.Summary_Count}}</td>
                  <td class="text-center">{{s.Balance_Amount}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="d-block summary-text-subt mt-10 col-md-12 col-sm-12 col-xs-12 ">Client summary view
          <div class="col-md-12 p-0 summary-text">
            <table class="summaryTable" width="100%">
              <tbody>
                <tr *ngFor="let s of Summary.Client_Summary">
                  <td>{{s.Summary_Name}}</td>
                  <td class="text-right">{{s.Summary_Count}}</td>
                  <td class="text-center">{{s.Balance_Amount}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="ShowMain" class="col-md-9">
    <div class="row">
      <div class="col-md-12 col-sm-12 p-0">
        <div class="heading-panel sT-hight p-0">
          <span class="text-sm text-ellipsis heading-txt t-uppercase blue-text">Categories</span>
        </div>
      </div>

      <div *ngIf="ShowAging" class="col-md-12 col-sm-12 mb-3 p-0">
        <button (click)="Search(a)" *ngFor="let a of AgingData"
          [ngClass]="[SelectedAging == a ? 'blue' : 'grey']"
          class="btn square-btn blue-hover btn-txt mr-5 reasonBucket">
          {{a.Ageing_Bucket_Name}}
          <span class="buckets-list-cl d-unset t-2">
            <b class="badge circle-buget" *ngIf="a.spin">
              <i class="fa fa-refresh fa-spin"></i>
            </b>
            <b *ngIf="!a.spin" class="badge circle-buget  badge-sm badge-pill">{{a.Ageing_Bucket_Count}}
              <span class="d-inline" *ngIf="a.Balance_Amount != '-'">|</span>
              {{a.Balance_Amount == '-' ? '' : a.Balance_Amount}}
            </b>
          </span>
        </button>
      </div>
      <div class="col-md-12 col-sm-12 p-0">
        <div class="table-responcive">
          <div class="sticky-table sticky-ltr-cells border-0 table-hight">
            <table class="table">
              <thead>
                <tr class="sticky-header">
                  <th class="dark">Disposition Category</th>
                  <th class="dark">Count</th>
                  <th class="dark">Dollar Value</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="Statuses.length == 0; else showRows">
                  <tr>
                    <td style="text-align: center" colspan="2">
                      No Status For available for Selected Action
                    </td>
                  </tr>
                </ng-container>
                <ng-template #showRows>
                  <tr *ngFor="let s of Statuses" (click)="GetInventories(s)">
                    <td [ngClass]="[SelectedStatus == s.Status_Name ? 'tr-active' : '']">{{s.Status_Name}}</td>
                    <td [ngClass]="[SelectedStatus == s.Status_Name ? 'tr-active' : '']">{{s.Status_Count}}</td>
                    <td [ngClass]="[SelectedStatus == s.Status_Name ? 'tr-active' : '']">{{s.Balance_Amount}}</td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
          <div style="margin-left: 46%;" *ngIf="loader">
            <i class="fa fa-refresh fa-spin fa-5x"></i>
            <!-- <p>Getting Information</p> -->
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- end midd content -->
<!-- <app-assistance-modal [TLAction]="Action" [Inventories]="Inventories" [Client_Id]="ClientId"
  [HeaderStatus]="PopupHeader" [InventoryCount]="StatusCount" (ClosePopup)="ToggleAssistanceModal($event)"
  *ngIf="ShowInventories"></app-assistance-modal> -->
<div style="text-align: center;margin-top: 14%;" *ngIf="searchloader">
  <i class="fa fa-refresh fa-spin fa-5x"></i>
  <p>Getting Information</p>
</div>
<app-assistance-modal [TLAction]="Action" [Inventories]="Inventories" [Client_Id]="ClientId"
  [HeaderStatus]="PopupHeader" [InventoryCount]="StatusCount" [InventoryExcelData]="InventoryExcelData"
  (ClosePopup)="ToggleAssistanceModal($event)" *ngIf="ShowInventories"></app-assistance-modal>
